import { render, staticRenderFns } from "./Stickers.vue?vue&type=template&id=1c73ea04&scoped=true&"
import script from "./Stickers.vue?vue&type=script&lang=ts&"
export * from "./Stickers.vue?vue&type=script&lang=ts&"
import style0 from "./Stickers.vue?vue&type=style&index=0&id=1c73ea04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c73ea04",
  null
  
)

export default component.exports